import { PortalkonfigurationDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-mail-confirmation',
    templateUrl: './mail-confirmation.component.html',
    styleUrls: ['./mail-confirmation.component.scss'],
    standalone: false
})
export class MailConfirmationComponent implements OnInit {

  public titleMessage: string;
  public message: string;
  
  protected email: string;
  protected portalkonfiguration: PortalkonfigurationDisplayModel;

  constructor(protected route: ActivatedRoute, protected languageservice: I18nService) {
    this.portalkonfiguration = route.snapshot.data.portalkonfiguration;
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.email = params.email;
        
        if (params.from == 'pre-register') {
          if (this.portalkonfiguration.isErneuteRegistrierungVorlageVorhanden) {
            this.titleMessage = this.languageservice.instant("mail.confirmtext1", { email: this.email });
            this.message = this.languageservice.instant("email-confirmation.pre-register");
          }
          else {
            this.titleMessage = this.languageservice.instant("mail.confirmtext2");
            this.message = this.languageservice.instant("email-confirmation.pre-register-if-not-registered");
          }
        }
        else if (params.from == 'reset-password') {
          this.titleMessage = this.languageservice.instant("mail.confirmtext2");
          this.message = this.languageservice.instant("email-confirmation.reset-password");
        }
      }
    );
  }
}
